export const formatSlidesForCarousel = (arr) => arr.map((slide, index) => ({
  key: `slide-${index + 1}`,
  props: { ...slide },
}));

export const getYearInReviewSlidesCS = ({
  heroContent,
  heroType,
  memberRewardInfo,
}) => {
  const model = heroContent?.[heroType];
  const rawSlides = model?.yearInReviewSlides;
  const empty = [{ key: 'foo', props: {} }];
  // eslint-disable-next-line
  if (!rawSlides) { console.log(`an issue occured with heroContent['${heroType}']`); return empty; }
  const { earnedReward } = memberRewardInfo;

  if (heroType === 'LOGGED_OUT' || heroType === 'NON_MEMBER') {
    const [
      weGaveBackModel,
      protectedLandModel,
      coopActionFundModel,
      CANModel,
      ourCommunityHasGrownModel,
    ] = rawSlides;

    const nonMemberUsers = [
      weGaveBackModel,
      protectedLandModel,
      coopActionFundModel,
      CANModel,
      ourCommunityHasGrownModel,
    ];
    return formatSlidesForCarousel(nonMemberUsers);
  }
  if (heroType === 'MEMBER') {
    const [
      weGaveBackModel,
      earnedInRewardsModel,
      protectedLandModel,
      coopActionFundModel,
      CANModel,
      ourCommunityHasGrownModel,
    ] = rawSlides;

    const nonRewardedUsers = [
      weGaveBackModel,
      protectedLandModel,
      coopActionFundModel,
      CANModel,
      ourCommunityHasGrownModel,
    ];

    /* c8 ignore start */
    if (earnedReward >= 1) {
      const { statistic: rawStatistic } = earnedInRewardsModel;
      const statistic = rawStatistic.replace(/{{.*}}/, earnedReward);
      const memberWithEarnedRewardsOrder = [
        weGaveBackModel,
        { ...earnedInRewardsModel, statistic },
        protectedLandModel,
        coopActionFundModel,
        CANModel,
      ];
      return formatSlidesForCarousel(memberWithEarnedRewardsOrder);
    }
    /* c8 ignore end */
    return formatSlidesForCarousel(nonRewardedUsers);
  }
  return empty;
};
